import React, { useState, useEffect } from 'react';
import './getpanverify.css';

const RepayLoan = () => {
  const [mobile, setMobile] = useState('');
  const [refStr, setRefStr] = useState('');
  const [responseMsg, setResponseMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('refstr');
    if (ref) {
      setRefStr(ref);
    }
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      // Build query string
      const apiUrl = `https://fundswalla.in/Api/TaskApi/getLeadInfo?lead_id=${refStr}&pan_number=${mobile}`;

      const res = await fetch(apiUrl);
      const text = await res.text(); // API sometimes sends HTML/text, not always JSON
      console.log("API Response:", text);

      setResponseMsg(text); // display result in UI
    } catch (error) {
      console.error("Error fetching API:", error);
      setResponseMsg("Something went wrong while verifying PAN.");
    }
  };

  return (
    <div className="repay-loan-page">
      {/* Hero Section with PAN Verification Title */}
      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">PAN Verification</h1>
        </div>
      </section>

      {/* Input Field and Submit Button */}
      <section className="container mt-5">
        <form
          onSubmit={handleSearch}
          className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4"
        >
          <input
            type="text"
            className="form-control"
            placeholder="Enter Your PAN Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          {/* hidden field for lead_id */}
          <input type="hidden" name="lead_id" value={refStr} />

          <button type="submit" className="btn custom-submit-btn">
            Submit
          </button>
        </form>

        {/* Show API response */}
        {responseMsg && (
          (() => {
            try {
              const parsed = JSON.parse(responseMsg);
              if (parsed.status === true) {
                return (
                  <div className="text-center mt-4">
                    <div className="success-icon mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9 12l2 2 4-4"></path>
                      </svg>
                    </div>
                    <h4 className="text-success fw-bold mb-2">Verification Successful!</h4>
                    <p className="text-muted" style={{ fontSize: '16px', maxWidth: '400px', margin: '0 auto' }}>
                      Your PAN has been successfully verified. We will now proceed to the next stage of the process.
                    </p>
                  </div>
                );
              } else {
                return (
                  <div className="text-center mt-4">
                    <div className="error-icon mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                    </div>
                    <h4 className="text-danger fw-bold mb-2">Verification Failed!</h4>
                    <p className="text-muted" style={{ fontSize: '16px', maxWidth: '400px', margin: '0 auto' }}>
                      The PAN number you entered is invalid or does not match our records. Please check and try again.
                    </p>
                  </div>
                );
              }
            } catch (e) {}
            return (
              <div className="alert alert-info mt-3">
                <div dangerouslySetInnerHTML={{ __html: responseMsg }} />
              </div>
            );
          })()
        )}
      </section>
    </div>
  );
};

export default RepayLoan;
